export const SPECIFIC_STORE_IDS = [
    "66fa79ff202a64f74440f72f",
    "661ccc77d93b1d5aa5773bc4",
    "663c12fa2f86dccce16e1c04",
    "663d7deece247b3e0f169380",
    "6649a7a7edd71892b0678e2c",
    "6660cb8c1af844a4196b2234",
    "6684ed2519f8447e8524b9bf",
    "668e797e985f2f3ed3233097",
    "66912dda1dec270f002d3bf4",
    "66b92617d887130eaab830c4",
    "66c7493b43cae532a88f3d96",
    "66e1aa385660a271e97b6035",
    "66ec4652b8c98467f89bdf05",
    "66eeb1d4cefce7c583434a45",
    "66f42711cb38382be018837d",
    "66fa5a3d81c98fd706c4f429",
    // our shops IDs
    "66f7b0820d0b39449663ea4a",
    "6567600c53785b104c6fcf0f"
];
